import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Skeleton } from 'components/ui/skeleton';
import { useLogout, useUser } from 'lib/auth';
import { ChevronsUpDown, LogOut } from 'lucide-react';
import { useStytchB2BClient } from '@stytch/react/b2b';

import { Avatar, AvatarFallback } from 'components/ui/avatar';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuTrigger,
} from 'components/ui/dropdown';
import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from 'components/ui/sidebar';
import { getInitials } from 'lib/utils';

export function NavUser() {
    const navigate = useNavigate();
    const user = useUser();
    const stytch = useStytchB2BClient();

    const onBackendLogoutSuccess = useCallback(() => {
        stytch.session.revoke();
        navigate('/authenticate');
    }, [stytch.session, navigate]);
    const logout = useLogout(onBackendLogoutSuccess);
    const { isMobile } = useSidebar();

    const onLogout = useCallback(() => {
        logout.mutate();
    }, [logout]);

    if (user.isLoading || !user.data) {
        return <Skeleton className="h-10 w-full" />;
    }

    return (
        <SidebarMenu>
            <SidebarMenuItem>
                <DropdownMenu modal={false}>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton
                            size="lg"
                            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                        >
                            <Avatar className="h-8 w-8 rounded-lg">
                                {/* <AvatarImage
                                    src={user.data.avatar}
                                    alt={user.data.name}
                                /> */}
                                <AvatarFallback className="rounded-lg bg-secondary">
                                    {getInitials(user.data.name)}
                                </AvatarFallback>
                            </Avatar>
                            <div className="grid flex-1 text-left text-sm leading-tight">
                                <span className="truncate font-semibold">
                                    {user.data.name}
                                </span>
                                <span className="truncate text-xs">
                                    {user.data.email}
                                </span>
                            </div>
                            <ChevronsUpDown className="ml-auto size-4" />
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-[--radix-dropdown-menu-trigger-width] min-w-56 rounded-lg"
                        side={isMobile ? 'bottom' : 'right'}
                        align="end"
                        sideOffset={4}
                    >
                        <DropdownMenuLabel className="p-0 font-normal">
                            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                                <Avatar className="h-8 w-8 rounded-lg">
                                    {/* <AvatarImage
                                        src={user.data.avatar}
                                        alt={user.data.name}
                                    /> */}
                                    <AvatarFallback className="rounded-lg">
                                        {getInitials(user.data.name)}
                                    </AvatarFallback>
                                </Avatar>
                                <div className="grid flex-1 text-left text-sm leading-tight">
                                    <span className="truncate font-semibold">
                                        {user.data.name}
                                    </span>
                                    <span className="truncate text-xs">
                                        {user.data.email}
                                    </span>
                                </div>
                            </div>
                            <div className="flex items-center px-1 py-1">
                                {
                                    <span className="truncate text-xs">
                                        {user.data.organization.name}
                                    </span>
                                }
                            </div>
                        </DropdownMenuLabel>
                        <DropdownMenuItem onClick={onLogout}>
                            <LogOut className="mr-2" />
                            Log out
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    );
}
